import React from 'react'
import { Typography } from '@mui/material';

const Page404 = () => {
  return (
    <main>
        <Typography>
          כתובת לא נכונה אין כלום בעמוד זה
        </Typography>
    </main>
  )
}

export default Page404